import { render, staticRenderFns } from "./FieldMedia.vue?vue&type=template&id=47b2c44c&scoped=true&"
import script from "./FieldMedia.vue?vue&type=script&lang=js&"
export * from "./FieldMedia.vue?vue&type=script&lang=js&"
import style0 from "./FieldMedia.vue?vue&type=style&index=0&id=47b2c44c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b2c44c",
  null
  
)

export default component.exports